import APICall from '../utils/APICall';
import TenantCall from '../utils/TenantCall';

export default class TenantServices {
    static getTenant = async (tenantName) => {
        return await TenantCall(`/api/Tenant/get-tenant-details/${tenantName}`, "GET")
    };
    static dashBoardSummary = async () => {
        return await APICall("/api/DashBoardSummary/admin/summary", "GET")
    }
    static shutDown = async (payload) => {
        return await APICall("/api/ApplicationSettings/admin/shutdown-application", "POST", payload)
    }
    static openApp = async (payload) => {
        return await APICall("/api​/ApplicationSettings​/admin​/open-application", "POST", payload)
    }
    static getAppStatus = async (payload) => {
        return await APICall(`/api/ApplicationSettings/admin/get-application?applicationParameter=${payload}`, "GET")
    }
    static transferGraph = async () => {
        return await APICall("/api/DashBoardSummary/admin/transfers-graph", "GET");
    }
    static billsGraph = async () => {
        return await APICall("/api/DashBoardSummary/admin/bills-graph", "GET")
    }
    static listTenanat = async (tenantName) => {
        return await APICall(`/api/Tenant/admin/view-tenant?tenantId=${tenantName}`, "GET");
    }  
    static updateTenant = async (payload) => {
        return await APICall("/api/Tenant/admin/update-tenant", "POST", payload)
    }
    static createBranch =async (payload) => {
        return await APICall("/api/Tenant/admin/create-branch", "POST", payload);
    }
    static updateBranch = async (payload) =>{
        return await APICall("/api/Tenant/admin/update-branch", "POST", payload);
    }
    static deleteBranch = async (payload) => {
        return await APICall (`/api/Tenant/admin/delete-branch`, "DELETE", payload)
    }
}